import angular from 'angular';

module.exports = angular.module('common.directives.select-all-on-focus', [])
.directive('selectAllOnFocus', function () {
  return function (scope, element){
    element.bind('focus', function () {
      this.select();
    });
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/select-all-on-focus.js
 **/